"use client";

import { useEffect } from "react";
import { debugError, debugLog, isDebug } from "@/shared/lib/debug";

export default function DebugMonitor() {
  useEffect(() => {
    if (!isDebug()) return;

    debugLog("debug", "Режим отладки включён (NEXT_PUBLIC_DEBUG=true)");

    const onError = (event: ErrorEvent) => {
      debugError("window", event.message, {
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
        error: event.error,
      });
    };

    const onUnhandledRejection = (event: PromiseRejectionEvent) => {
      debugError("promise", "Unhandled rejection", event.reason);
    };

    window.addEventListener("error", onError);
    window.addEventListener("unhandledrejection", onUnhandledRejection);

    return () => {
      window.removeEventListener("error", onError);
      window.removeEventListener("unhandledrejection", onUnhandledRejection);
    };
  }, []);

  return null;
}
